module.exports = __webpack_public_path__ + "static/img/d201.9b00a600.png";